import type { RouteRecordRaw } from 'vue-router'

export const CUSTOMER_CARE = {
  DIAGNOSIS: {
    SELF: 'diagnosis',
  },
  RESOLUTION: {
    SELF: 'resolution',
    SELF_FROM_DIAGNOSIS_V2: 'resolution_from_diagnosis_v2',
    RESOLUTION_CONTACT_CONFIRMATION: 'resolution_contact_confirmation',
    RESOLUTION_RETURN_CONFIRMATION: 'resolution_return_confirmation',
  },
}

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/dashboard/diagnosis/new/:orderlineId',
    name: CUSTOMER_CARE.DIAGNOSIS.SELF,
    component: () => import('./Noop.vue'),
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
    },
  },
  {
    path: '/:locale/dashboard/claim/new/:orderlineId/:tilesIds',
    name: CUSTOMER_CARE.RESOLUTION.SELF,
    redirect: { name: CUSTOMER_CARE.DIAGNOSIS.SELF },
  },
  {
    path: '/:locale/dashboard/resolution/new/:orderlineId/:customerIssues',
    name: CUSTOMER_CARE.RESOLUTION.SELF_FROM_DIAGNOSIS_V2,
    component: () => import('./Noop.vue'),
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
    },
  },
  {
    path: '/:locale/dashboard/resolution/confirmation/:resolutionId?',
    name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_CONTACT_CONFIRMATION,
    component: () => import('./Noop.vue'),
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
    },
  },
  {
    path: '/:locale/dashboard/resolution/return/confirmation/:resolutionId',
    name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_RETURN_CONFIRMATION,
    component: () => import('./Noop.vue'),
    meta: {
      auth: {
        required: true,
      },
      disableClientSideNavigation: () => true,
    },
  },
]

export default routes
